import React from 'react';
import '../styles/_spinner.scss';

const Spinner = ({ color }) => {
  return (
    <div className={`loader ${color ? color : ''}`}></div>
  )
}

export default Spinner;